"use strict";

var _regeneratorRuntime = require("/codebuild/output/src532132034/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _uiKit = require("@devsta/ui-kit");

var _EditOrganisationStage = _interopRequireDefault(require("../../EditOrganisationStage"));

var _UploadContract = _interopRequireDefault(require("./UploadContract"));

var _utils = require("../../../utils");

require("../styles/_contract-and-terms.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function isContractAndTermsValid(state) {
  var uploadedContract = state.uploadedContract,
      contractUrl = state.contractUrl,
      isValidContract = state.isValidContract;
  return isValidContract && (uploadedContract || contractUrl);
}

var ContractAndTerms = /*#__PURE__*/function (_Component) {
  _inherits(ContractAndTerms, _Component);

  function ContractAndTerms(props) {
    var _this;

    _classCallCheck(this, ContractAndTerms);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ContractAndTerms).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getOrgAdminRole", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var getOrganisationRoles, _ref2, _ref2$data, roles, error;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getOrganisationRoles = _this.props.getOrganisationRoles;
              _context.next = 3;
              return getOrganisationRoles();

            case 3:
              _ref2 = _context.sent;
              _ref2$data = _ref2.data;
              _ref2$data = _ref2$data === void 0 ? {} : _ref2$data;
              roles = _ref2$data.getRoles, error = _ref2.error;

              if (!error) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", {
                error: error,
                roleId: ''
              });

            case 9:
              return _context.abrupt("return", roles.find(function (_ref3) {
                var name = _ref3.name;
                return name === 'ADMIN';
              }));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "onCompleteSetup", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$props, history, organisation, apolloClient, updateOrganisation, inviteUser, uploadedContract, contractBucketKey, _ref5, fileError, _ref6, roleId, roleError, _ref7, inviteError, _ref8, error;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this$props = _this.props, history = _this$props.history, organisation = _this$props.organisation, apolloClient = _this$props.apolloClient, updateOrganisation = _this$props.updateOrganisation, inviteUser = _this$props.inviteUser;
              uploadedContract = _this.state.uploadedContract;
              contractBucketKey = (0, _utils.buildBucketKey)('organisation', organisation.organisationId, 'contract');

              _this.setState({
                saving: true
              });

              _context2.next = 6;
              return (0, _utils.saveOptionalFile)({
                apiClient: apolloClient,
                key: contractBucketKey,
                file: uploadedContract,
                organisationId: organisation.organisationId
              });

            case 6:
              _ref5 = _context2.sent;
              fileError = _ref5.error;

              if (!fileError) {
                _context2.next = 10;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                saving: false
              }));

            case 10:
              if (!(organisation.status !== 'DRAFT')) {
                _context2.next = 12;
                break;
              }

              return _context2.abrupt("return", void history.push('organisations'));

            case 12:
              _context2.next = 14;
              return _this.getOrgAdminRole();

            case 14:
              _ref6 = _context2.sent;
              roleId = _ref6.roleId;
              roleError = _ref6.error;

              if (!roleError) {
                _context2.next = 19;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                saving: false
              }));

            case 19:
              _context2.next = 21;
              return inviteUser({
                email: organisation.invitedUserEmail,
                roleId: roleId
              });

            case 21:
              _ref7 = _context2.sent;
              inviteError = _ref7.error;

              if (!inviteError) {
                _context2.next = 25;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                saving: false
              }));

            case 25:
              _context2.next = 27;
              return updateOrganisation({
                input: {
                  status: 'ACTIVE',
                  contractUrl: contractBucketKey
                }
              });

            case 27:
              _ref8 = _context2.sent;
              error = _ref8.error;

              if (!error) {
                _context2.next = 31;
                break;
              }

              return _context2.abrupt("return", void _this.setState({
                saving: false
              }));

            case 31:
              history.push('organisations');

            case 32:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    })));

    _defineProperty(_assertThisInitialized(_this), "setContract", function (_ref9) {
      var contract = _ref9.contract,
          isValidFile = _ref9.isValidFile;

      _this.setState({
        uploadedContract: contract,
        isValidContract: isValidFile
      });
    });

    var _organisation = props.organisation;
    _this.state = {
      saving: false,
      allTermsAccepted: false,
      uploadedContract: void 0,
      isValidContract: Boolean(_organisation.contractUrl),
      contractUrl: _organisation.contractUrl || ''
    };
    return _this;
  }

  _createClass(ContractAndTerms, [{
    key: "render",
    value: function render() {
      var hasUpdatePermission = this.props.hasUpdatePermission;
      var _this$state = this.state,
          contractUrl = _this$state.contractUrl,
          saving = _this$state.saving;
      return _react.default.createElement(_EditOrganisationStage.default, {
        title: "Contract & Terms"
      }, _react.default.createElement("div", {
        className: "contract-and-terms"
      }, _react.default.createElement(_UploadContract.default, {
        title: "Agreement Contract*",
        onUploadContract: this.setContract,
        initialContract: contractUrl,
        disabled: !hasUpdatePermission
      }), _react.default.createElement(_uiKit.Button, {
        id: "submit-button",
        busy: saving,
        onClick: this.onCompleteSetup,
        disabled: saving || !isContractAndTermsValid(this.state) || !hasUpdatePermission
      }, "Complete Setup")));
    }
  }]);

  return ContractAndTerms;
}(_react.Component);

exports.default = ContractAndTerms;